import { useState } from "react";
import { FinanceBilledTo } from "../../models/finance.model";
import { formatCurrency } from "../../utils";
import { colors } from "../../utils/constants";
import DountGraph from "../DonutGraph/DonutGraph";
import Tabs from "../Tabs/Tabs";
import { AnnualPlanRevenueData } from "../../models/annual-plan.model";

export const serviceBilledToObj: any = {
  Single: {
    name: "Individual Plan",
    color: colors.GreenYellow,
  },
  Couple: {
    name: "Couples Plan",
    color: colors.Orange,
  },
  Family: {
    name: "Family Plan",
    color: colors.CyanBlue,
  },
  Senior: {
    name: "Senior Individual Plan",
    color: colors.Lilac,
  },
  "Senior Couple": {
    name: "Senior Couples Plan",
    color: colors.PictonBlue,
  },
};

const OfficeFinanceTabGraphSection = ({ annualPlanRevenueByPlan }: { annualPlanRevenueByPlan: AnnualPlanRevenueData }) => {
  const [activeTab, setActiveTab] = useState(0);
  const totalAmount = annualPlanRevenueByPlan.revenueTotal;
  const totalCount = annualPlanRevenueByPlan.subscribersTotal;
  const billedTo: FinanceBilledTo[] = annualPlanRevenueByPlan.plans.map(item => {
    return {
      billedTo: item.plan,
      count: item.subscribers,
      amount: item.revenue,
    };
  });
  const Tab1 = () => {
    return (
      <div className="mt-10">
        {billedTo?.length ? (
          <DountGraph
            location="AnnualTab"
            height={350}
            billedToList={billedTo}
            graphLabel={"Total Annual Plan Revenue"}
            graphVal={false}
            totalCount={formatCurrency((totalAmount / 100)?.toString(), "blur")}
          />
        ) : null}
      </div>
    );
  };
  const Tab2 = () => {
    return (
      <div className="mt-10 relative">
        {billedTo?.length ? (
          <DountGraph
            location="AnnualTab"
            height={350}
            billedToList={billedTo}
            graphLabel={"Number of Subscribers"}
            graphVal={true}
            totalCount={totalCount.toString()}
          />
        ) : null}
      </div>
    );
  };

  return (
    <div className="finance-graph mt-10">
      <Tabs
        components={[]}
        options={[`REVENUE BY PLAN TYPE`, "NUMBER OF SUBSCRIBERS"]}
        activeTab={activeTab}
        onClickTab={setActiveTab}
        fromOffice={true}
      />
      <div className="w-full block lg:flex">
        {billedTo?.length ? (
          <div className="w-full lg:w-1/2 flex items-center justify-center">
            <div className="flex flex-col w-full mt-5 lg:mt-0 items-center">
              {billedTo.map((item: FinanceBilledTo) => {
                return (
                  <div key={item?.billedTo} className="flex w-full lg:w-2/3 text-docsigna-blue-ldark border-b border-docsigna-blue-dark py-3">
                    <div className="flex w-2/3">
                      <div
                        className="w-5 h-5 rounded-full mr-3"
                        style={{ backgroundColor: serviceBilledToObj[item?.billedTo]?.color ?? "transparent" }}
                      />
                      <p className="text-sm font-semibold">{serviceBilledToObj[item?.billedTo]?.name ?? ""}</p>
                    </div>
                    <div className="text-sm font-semibold text-right mr-5 w-1/3">
                      {activeTab === 1 ? item.count : formatCurrency((item?.amount / 100)?.toString(), "blur")}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
        <div className="w-full lg:w-1/2">{activeTab === 0 ? <Tab1 /> : <Tab2 />}</div>
      </div>
    </div>
  );
};

export default OfficeFinanceTabGraphSection;
